import { render, staticRenderFns } from "./InventorySector.vue?vue&type=template&id=5ab34800&scoped=true"
import script from "./InventorySector.vue?vue&type=script&lang=js"
export * from "./InventorySector.vue?vue&type=script&lang=js"
import style0 from "./InventorySector.vue?vue&type=style&index=0&id=5ab34800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab34800",
  null
  
)

export default component.exports